module.exports = __webpack_public_path__ + "static/media/airtel-wallet.df2ae5a4.svg";